import { render, staticRenderFns } from "./VoiceAgentCallMessage.vue?vue&type=template&id=297d80ef&scoped=true"
import script from "./VoiceAgentCallMessage.vue?vue&type=script&lang=js"
export * from "./VoiceAgentCallMessage.vue?vue&type=script&lang=js"
import style0 from "./VoiceAgentCallMessage.vue?vue&type=style&index=0&id=297d80ef&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "297d80ef",
  null
  
)

export default component.exports